<template>
	<datatable :value="items" :headers expandable :loading :rows="9999" :paginator="false">
		<template #row-quantity_required="{ row }">
			{{ Number(row.quantity_required).toFixed(0) }}
		</template>
	</datatable>
</template>

<script lang="ts" setup>
	import type { Header } from '@/data/types/datatable'
	import type { JourneyItem } from '@/data/schema/journey-item'

	defineProps({
		items: {
			type: Array<JourneyItem>,
			default: []
		},
		loading: Boolean
	})

	const headers: Header[] = [
		{ value: 'item_number', text: 'Item No', props: { sortable: true, width: 150 } },
		{ value: 'item_description', text: 'Item Description', props: { sortable: true } },
		{ value: 'quantity_required', text: 'Qty', props: { sortable: true, width: 60 } }
	]
</script>
